/** Result panel (C slot) — show/reset the result image, the loading skeleton, and the off-intent image toolbar. Split from dialog-shell.js (1 file 1 duty; setResultError stays in dialog-shell — its Retry re-fires the generate handler held there). */

import { store } from '../../../core/store.js'
import { renderImageToolbar } from '../../create-ui/image-tools.js'
import { escHtml } from './shell-scaffold.js'

/**
 * Show a generated image in the C (result) slot, sync `creation.result`, reveal
 * the funnel CTA, and mount the off-intent image toolbar beside the actions.
 * @param {string} url
 * @param {string|null} [generationId=null]
 * @param {Array<string|number>} [cardIds=[]] - cards used, for adopt/discard tracking
 * @param {string|number|null} [assetId=null] - persisted asset id for Refine chaining
 */
export function showResultImage(url, generationId = null, cardIds = [], assetId = null) {
  const ph = document.getElementById('dialogResultPh')
  const img = document.getElementById('dialogResultImg')
  const actions = document.getElementById('dialogResultActions')
  if (!img) return
  img.src = url; img.classList.remove('hidden')
  if (ph) ph.style.display = 'none'
  if (actions) actions.classList.remove('hidden')
  document.getElementById('funnelCta')?.classList.remove('hidden')

  const ids = Array.isArray(cardIds) ? cardIds.filter(Boolean) : []
  store.setState('creation.result', { url, generation_id: generationId, card_ids: ids, asset_id: assetId })

  // Off-intent image tools beside the result (remove-bg / upscale / segment).
  if (actions) {
    let toolsEl = document.getElementById('dialogResultTools')
    if (!toolsEl) {
      toolsEl = document.createElement('div'); toolsEl.id = 'dialogResultTools'; toolsEl.className = 'result-tools'
      actions.appendChild(toolsEl)
    }
    // Keep the asset_id in the re-shown result: the tool response's own asset id
    // when it returns one, else null (Refine then materializes the URL at
    // generate time). Dropping the 4th arg here used to null asset_id and break
    // the Refine → next-generate source ref. why → review F5.
    renderImageToolbar(toolsEl, () => store.getState('creation.result')?.url || url, (newUrl, toolRes) => showResultImage(newUrl, generationId, ids, toolRes?.asset_id ?? null))
  }
}

/**
 * Reset the C slot back to its empty placeholder and hide actions + funnel CTA.
 */
export function resetResultSlot() {
  const ph = document.getElementById('dialogResultPh')
  const img = document.getElementById('dialogResultImg')
  const actions = document.getElementById('dialogResultActions')
  if (img) { img.src = ''; img.classList.add('hidden') }
  if (ph) { ph.style.display = ''; ph.innerHTML = '<i class="ph ph-image-square"></i><span>Add an image or pick an action, then Generate</span>' }
  if (actions) actions.classList.add('hidden')
  document.getElementById('funnelCta')?.classList.add('hidden')
}

/**
 * Put the C slot into its loading state (skeleton + label).
 * @param {string} [text] - status label, defaults to "Generating…"
 */
export function setResultLoading(text) {
  const ph = document.getElementById('dialogResultPh')
  const img = document.getElementById('dialogResultImg')
  if (img) img.classList.add('hidden')
  // Skeleton, not a bare spinner (>1s feels stuck). why → ui-ux-pro-max progressive-loading.
  if (ph) {
    ph.style.display = ''
    ph.innerHTML = `<div class="cw-result-sk"></div><span class="cw-result-skt">${escHtml(text || 'Generating…')}</span>`
  }
  document.getElementById('funnelCta')?.classList.add('hidden')
}

/**
 * Sync the C slot with `creation.result`: reset to placeholder when empty.
 * Store-subscriber callback registered by initDialogShell.
 */
export function showResult() {
  const wrap = document.getElementById('dialogResult')
  if (!wrap) return
  const r = store.getState('creation.result')
  if (!r?.url) resetResultSlot()
}
